<template>
<div class="post-header">
  <h2 v-if="detailProcess.title" class="post-title">{{detailProcess.title}}</h2>
  <h4 v-if="detailProcess.subtitle" class="post-subtitle">{{detailProcess.subtitle}}</h4>
  <div class="post-content">
    <p v-if="typeof detailProcess.description === 'string'" v-html="detailProcess.description"></p>
    <div v-else class="col-xs-12">
      <div :class="processColumnClass" v-for="(proccessList, index) in detailProcess.description" :key="index">
        <ul class="detail-process-list">
          <li v-for="(detailProcess,subIndex) in proccessList" :key="`${index}-${subIndex}`">
            {{detailProcess}}
          </li>
        </ul>
      </div>
  </div>
    <div v-for="(image, index) in detailProcess.images" v-bind:key="index" >
      <img v-if="image.src"
        :src="image.src"
        :alt="image.alt" 
        class="mb-20"
        @load="$emit('image-loaded')"/>
      <video class="project-detail-video mb-20" v-else-if="image.video" controls autoplay loop muted>
        <source :src="image.video" type="video/mp4">
      </video>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    detailProcess: Object
  },
  computed: {
    processColumnClass: function() {
      if (Array.isArray(this.detailProcess.description)) {
        if(Array.isArray(this.detailProcess.description[0])) {
          return "col-xs-4";
        }
      }
      return "col-xs-12";
    }
  }
}
</script>
<style scoped>
.detail-process-list li:first-child {
  list-style-type: none;
  margin-bottom: 5px;
  margin-left: -15px;
  font-weight: 600;
}

.detail-process-list li {
  list-style-type: square;
  margin-bottom: 10px;
}

.post-subtitle {
  font-size: 18px;
  text-transform: unset;
}
.project-detail-video {
  width: 100%;
  height: auto;
}
</style>